const productUpsellModal = {
  trigger: document.querySelector('.product-upsell__trigger'),
  modal: document.getElementById('product-upsell'),
  modalClose: null,
  modalProducts: null,
  modalHideClass: 'hidden',
  
  init() {
    if ( !this.modal ) { return }
    this.modalClose = this.modal?.querySelector('#product-upsell-close');
    this.modalProducts = this.modal?.querySelectorAll('[data-id=product-upsell-form]');
    this.bindEvents();
    this.varintUpdate();
  },

  showModal() {
    this.modal.classList.remove(this.modalHideClass);
  },

  closeModal() {
    this.modal.classList.add(this.modalHideClass);
  },

  async onSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);
    const cartData = Object.fromEntries(formData.entries());
    const { quantity } = cartData;
    const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(cartData)
    });
    const data = await response.json();
    const cartCountEl = document.querySelectorAll('.cart_count')
    console.log({cartCountEl})
    Array.from(cartCountEl).forEach(cartCount => {
      if (cartCount) {
        const text = cartCount.innerText || cart.textContent;
        const currentNumber = Number(text)
        const newNumber = Number(currentNumber) + Number(quantity);
        cartCount.textContent = `${newNumber}`;
      }
    })
    this.closeModal();
  },

  bindEvents() {
    if (this.trigger) {
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.showModal();
      });
    }

    if (this.modal) {
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          event.preventDefault();
          this.closeModal();
        }
      });
    }

    if (this.modalClose) {
      this.modalClose.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeModal();
      });
    }
    if (this.modalProducts) {
      this.modalProducts.forEach((productForm) => {
        productForm.addEventListener('submit', (event) => {
          event.preventDefault();
          this.onSubmit(event);
        });
      });
    }
  },

  varintUpdate() {
    const variantInputs = this.modal?.querySelectorAll('.product-upsell__product-variant-input')

    if (variantInputs) {

      variantInputs.forEach(input => {
        input.addEventListener('change', () => {
          const currentVariantId = input.getAttribute('data-current-variant-id');
          const currentVariantTitle = input.getAttribute('data-current-variant-title');
          const currentUpsellProductId = input.getAttribute('data-upsell-product-id');
          const variantTitleEle = this.modal?.querySelector(`.selected-variant-title[data-upsell-product-id='${currentUpsellProductId}']`);
          if (variantTitleEle) {
            variantTitleEle.innerText = currentVariantTitle;
          }
          const targetFormEle = this.modal?.querySelector(`.product-upsell__product-form[data-upsell-product-id='${currentUpsellProductId}']`);
          if (targetFormEle) {
            const formVariantIdInput = targetFormEle.querySelector('.variant-id');
            formVariantIdInput?.setAttribute('value', currentVariantId);
          }
        });
      });
    }
  }
};

productUpsellModal.init();